import { render, staticRenderFns } from "./AdvantageCampaignBudget.ts.vue?vue&type=template&id=3284371f"
import script from "./AdvantageCampaignBudget.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvantageCampaignBudget.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports